import { Spacer } from '@sparemin/blockhead';
import cn from 'classnames';
import * as React from 'react';

import { block } from '../utils';
import { BlueskyReplyLevelSelectorOption } from './types';

export type ReplyLevelOptionProps = {
  option: BlueskyReplyLevelSelectorOption;
  selected?: boolean;
  className?: string;
  onClick?: (value: any) => void;
};

const ReplyLevelOption: React.FC<ReplyLevelOptionProps> = ({
  option,
  selected = false,
  className,
  onClick,
}) => {
  const { label, logo, value } = option;

  return (
    <Spacer
      space="8px"
      align="center"
      justify="flex-start"
      className={cn(block('option', { selected }), className)}
      onClick={() => onClick(value)}
    >
      {logo}

      <span className={block('option-label')}>{label}</span>
    </Spacer>
  );
};

export default ReplyLevelOption;
